function jdCardCarousel() {
  const exp = document.querySelector('#jd-examples-bar');

  if (exp !== null) { // Only execute JD example card logic if they're present; i.e., only on the child template not the index.
    const cardsContainer = exp.querySelector('.jd-examples-cards');
    // Calculate number of items based on server-side rendered cards
    const cardList = exp.querySelectorAll('.jd-examples-card');
    const numItems = cardList.length;
    const numCardsPerViewOnDesktop = 3;
    const numCardsPerGroupOnDesktop = 3;
    const numCardsPerViewOnMobile = 1.1; // A decimal allows you to show part of the next card.
    const numCardsPerGroupOnMobile = 1;

    // Add a classname when there is only one card, so we can adjust CSS appropriately.
    if (numItems === 1) {
      cardsContainer.classList.add('jd-examples-cards-single');
    }

    // Set a desktop media query.
    let desktopMq = window.matchMedia('(min-width: 768px');

    // Initialize Swiper library.
    const swiper = new Swiper('.swiper', {
      slidesPerView: numCardsPerViewOnMobile,
      slidesPerGroup: numCardsPerGroupOnMobile,
      spaceBetween: 5,
      slideToClickedSlide: true,
      simulateTouch: false,
      watchSlidesProgress: true, // Enables calculating if a slide is visible.
      breakpoints: {
        768: {
          slidesPerView: numCardsPerViewOnDesktop,
          slidesPerGroup: numCardsPerGroupOnDesktop
        }
      },
      navigation: {
        nextEl: '.jd-examples-change-page-right-btn',
        prevEl: '.jd-examples-change-page-left-btn'
      },
      pagination: {
        el: '.jd-examples-page-count',
        type: 'fraction'
      },
      on: {
        // Close all open cards on page change to prevent the card position shifting due to a hanging 'expand left' class.
        slideChange: () => closeAllOpenCards()
      }
    });

    // Get all open cards in a function for reusability.
    function getOpenCards() {
      return exp.querySelectorAll('.jd-examples-card-open');
    }

    // Close all open cards in a function for reusability.
    function closeAllOpenCards() {
      const openCards = getOpenCards();
        if (openCards.length > 0) {
        openCards.forEach((openCard) => {
          openCard.classList.remove('jd-examples-card-open', 'jd-examples-card-expand-left');
        });
      }
    }

    // Click to toggle cards open/closed.
    function clickToggleCard(e) {
      const curCard = e.currentTarget;
      const selection = window.getSelection();
      // If the user is selecting text, don't close/open the card.
      if (selection.toString().length !== 0) {
        return;
      }

      // Scroll to top of the card so that it doesn't end up closed and scrolled.
      curCard.scroll({ top: 0 });

      // Close any other open cards before we open the current card.
      const openCards = getOpenCards();
      if (openCards.length > 0) {
        openCards.forEach((openCard) => {
          if (!openCard.contains(curCard)) {
            openCard.classList.remove('jd-examples-card-open', 'jd-examples-card-expand-left');
          }
        });
      }

      if (desktopMq.matches) {
        // On desktop, make the last visible card in the group expand to the left.
        // This can't be done using the :nth-of-type or :last-of-type CSS selectors on .swiper-slide-visible
        // because the behavior does not quite reflect what you'd expect; typically it either still
        // affects the previous set of visible slides or it only affects the last slide in the entire carousel.
        const  visibleCards = exp.querySelectorAll('.swiper-slide-visible'); // Slides visible in the viewport, determined by Swiper.
        if (
          visibleCards.length > 0
          && visibleCards.length >= numCardsPerGroupOnDesktop
          && curCard.isEqualNode(visibleCards[visibleCards.length - 1])
        ) {
          curCard.classList.toggle('jd-examples-card-expand-left');
        }
      } else {
        // On Mobile, scroll back up to the top of the section when closing a card.
        if (curCard.classList.contains('jd-examples-card-open')) {
          exp.querySelector('.jd-examples-title').scrollIntoView({ behavior: 'smooth' });
        }
      }

      // Open the current card.
      curCard.classList.toggle('jd-examples-card-open');
    }

    // Toggle cards open/closed with the keyboard.
    function keyboardToggleCard(e) {
      if (
        (e.key === 'Enter' || e.key === ' ') // If Enter or space keys are pressed, toggle open/closed.
        || e.key === 'Escape' && e.currentTarget.classList.contains('jd-examples-card-open') // If Escape key is pressed on an open card, close it.
      ) {
        e.preventDefault(); // Prevent spacebar from scrolling.
        clickToggleCard(e);
      }
    }

    // Use IntersectionObserver to ensure that only cards that are fully on screen can be toggled open/closed.
    // On small screens we're showing one full card with the next card mostly off-screen,
    // and we don't want users to be able to open the off-screen card.
    const observerOptions = {
      // Use the card container as the root container.
      root: document.querySelector('.jd-examples-carousel'),
      // The `intersectionRatio` to set `isIntersecting` to `true`.
      // For some reason mobile Safari returns an `intersectionRatio` slightly less than 1
      // for the visible card when the carousel is advanced, so we need to set the threshold
      // a bit lower than 1.
      threshold: 0.8,
    }

    // Add or remove event listeners to the cards depending on whether or not they are intersecting/visible.
    const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.addEventListener('click', clickToggleCard);
          entry.target.addEventListener('keydown', keyboardToggleCard);
        } else {
          entry.target.removeEventListener('click', clickToggleCard);
          entry.target.removeEventListener('keydown', keyboardToggleCard);
        }
      })
    }

    // Iniitalize the InterSectionObserver for each card.
    const cardIntersectionOberver = new IntersectionObserver(observerCallback, observerOptions);
    cardList.forEach((card) => {
      cardIntersectionOberver.observe(card)
    });

    // Close open cards on resize.
    // ResizeObserver is preferable to the window resize event listener for performance reasons.
    // Get the initial slider element width.
    let initialSliderWidth = Math.round(exp.getBoundingClientRect().width);
    const sliderResizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        // Get the slider width as it changes on resize
        const sliderWidth = Math.round(entry.contentRect.width);

        // If the initial width and the resize width are different, close the open card.
        if (sliderWidth !== initialSliderWidth) {
          closeAllOpenCards();
          // Reset the inital slider width, otherwise the widths will be different and the cards won't open again.
          initialSliderWidth = Math.round(exp.getBoundingClientRect().width);
        }
      }
    });
    sliderResizeObserver.observe(exp);
  }
}

window.addEventListener('DOMContentLoaded', jdCardCarousel);
